(function ($, Promise) {

		// Constructor
		function SkillGamesGame3LandingSpot(parent) {

			this.parent = parent;

			this.enabled = false;
			this.logicSize = 120;
			this.angle = 0;
			this.position = {
				x: 0,
				y: 0,
			}

			// Graphic holder
			this.graphic = new PIXI.Container();

			// Lines
			this.lines = [];
			var count = 10;
			for (var i = 0; i < count; i++) {

				var radians = (i / (count - 1)) * Math.PI * 1.2 - (0.1 * Math.PI) + Math.PI / 2;
				var width = 15;
				var height = 6;
				var radius = 80;

				var line = new PIXI.Graphics();
				line.beginFill(0xFFFFFF);
				line.drawRect(-width / 2, -height / 2, width, height);
				line.x = Math.cos(radians) * radius;
				line.y = Math.sin(radians) * radius;
				line.rotation = radians;
				this.graphic.addChild(line);
				this.lines.push(line);
			}

			this.animation = this.createAnimationTimeline();

		}

		SkillGamesGame3LandingSpot.prototype.setPosition = function (x, y) {
			this.position.x = x;
			this.position.y = y;
			this.graphic.position.x = x;
			this.graphic.position.y = y;
		}

		SkillGamesGame3LandingSpot.prototype.setAngle = function (value) {
			this.angle = value;
			this.graphic.rotation = value;
		}

		SkillGamesGame3LandingSpot.prototype.createAnimationTimeline = function () {

			// Animate timeline
			var tl = new TimelineMax({
				repeat: -1,
				paused: true,
			});

			// Animate in
			for (var i = 0; i < this.lines.length; i++) {
				tl.fromTo(this.lines[i].scale, 0.1, {
					x: 0,
					y: 0,
				}, {
					x: 1,
					y: 1,
					easing: Sine.easeInOut
				}, i * 0.1);
			}

			// Animate out
			var part2StartAt = tl.duration();
			for (var i = 0; i < this.lines.length; i++) {
				tl.to(this.lines[i].scale, 0.1, {
					x: 0,
					y: 0,
					easing: Sine.easeInOut
				}, (part2StartAt + i * 0.1));
			}

			return tl;
		}

		SkillGamesGame3LandingSpot.prototype.enable = function (value) {
			if (value) {
				this.enabled = value;
				this.animation.play();
			} else {
				this.enabled = value;
				this.animation.progress(1, false);
				this.animation.stop();
			}
		}

		SkillGamesGame3LandingSpot.prototype.reset = function () {
		}

		// Expose SkillGamesGame3LandingSpot
		window.SkillGamesGame3LandingSpot = SkillGamesGame3LandingSpot;
	}
)
(jQuery, Promise);
